/*
 *  -----------------------------------------------------------------------
 *    <copyright file="signatory.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { useTranslation, useGridCells } from 'hooks';
import { restructuredUpdatedCreatedBy } from '@utils-clean/update-users-array';
import Button from 'views/components/core/buttons/button';
import ExpandableGrid from 'views/components/core/expandable/grid/index';

import './styles.scss';

const PDFSignatory = ({ data, actions, openNew, canEdit }: any) => {
    const { t } = useTranslation();
    const [items, setItems] = useState(null);

    const { StandardCell, DateCell } = useGridCells();

    useEffect(() => {
        let array = data;
        array = restructuredUpdatedCreatedBy(array);
        setItems(array);
    }, [data]);

    return (
        <div className="report-wrapper">
            <div className="header">
                <p className="title">{t('reports:reportSignatories')}</p>
                <Button
                    id="new-signatory"
                    className="new-btn-pdf-report"
                    onClick={() => {
                        openNew(true);
                    }}
                    disabled={!canEdit}
                >
                    <FontAwesomeIcon icon={['far', 'layer-plus']} className="layer-plus" />
                </Button>
            </div>
            <div className="content">
                <ExpandableGrid
                    customKey="signatory-grid"
                    id="signatoryGrid"
                    items={items}
                    rowActions={actions}
                    groupable={false}
                    showPager
                    scrollable="scrollable"
                    reorderable
                    pageable={false}
                    resizable
                    addScroll={false}
                    options={{
                        allowExcelExport: false,
                        allowExpandCollapseAll: false,
                        useFilterChips: true,
                    }}
                    detail={null}
                    columns={[
                        {
                            label: t('role'),
                            id: 'signatory-role',
                            field: 'role',
                            minWidth: 140,
                            cells: { data: StandardCell(true) },
                        },
                        {
                            field: 'firstName',
                            id: 'signatory-first-name',
                            label: t('firstName'),
                            minWidth: 230,
                        },
                        {
                            field: 'lastName',
                            id: 'signatory-last-name',
                            label: t('lastName'),
                            minWidth: 230,
                        },
                        {
                            field: 'title',
                            id: 'signatory-job-title',
                            label: t('reports:jobTitle'),
                            minWidth: 230,
                        },
                        {
                            label: t('ra:createdBy'),
                            id: 'signatory-createdby',
                            field: '_createdByString',
                            showByDefault: false,
                            minWidth: 180,
                        },
                        {
                            label: t('ra:createdDate'),
                            id: 'signatory-created',
                            minWidth: 200,
                            field: 'created',
                            showByDefault: false,
                            cells: { data: DateCell },
                            filter: 'date',
                        },
                        {
                            label: t('ra:updatedBy'),
                            id: 'signatory-updatedby',
                            field: '_updatedByString',
                            showByDefault: false,
                            minWidth: 180,
                        },
                        {
                            label: t('ra:updatedDate'),
                            field: 'updated',
                            id: 'signatory-updated',
                            minWidth: 200,
                            filter: 'date',
                            showByDefault: false,
                            cells: { data: DateCell },
                        },
                        {
                            field: 'recordId',
                            id: 'signatory-id',
                            showByDefault: false,
                            label: 'ID',
                            filter: 'numeric',
                            minWidth: 140,
                        },
                    ]}
                />
            </div>
        </div>
    );
};

export default PDFSignatory;
